import { Injectable } from '@angular/core';

@Injectable()

export class InformationBoxService {
    public _botones: number;
    constructor() {
        this._botones = 1;
     }

     set currentButton(value) {
        this._botones = value;
      }
    
      get currentButton() {
        return this._botones;
      }
    
}
